import React, { useState,useEffect } from 'react';
import { Upload, X } from 'lucide-react';
import defImg from './noimage.png'
import './style.css';

const BusinessImgUpload = React.forwardRef(({ setImageUrl, setAlign, setWidth, setHeight,setBizRegCert ,bizRegCert}, ref) => {
  const [dragOver, setDragOver] = useState(false);
 // bizRegCert가 존재하면 초기값으로 설정, 없으면 defImg 사용
 const [previewUrl, setPreviewUrl] = useState(
  bizRegCert ? [{ url: bizRegCert }] : [{ url: defImg }]
);

useEffect(() => {
  if (bizRegCert && bizRegCert !== '') {
    setPreviewUrl([{ url: bizRegCert }]);
  } else {
    setPreviewUrl([{ url: defImg }]);
  }
}, [bizRegCert]);
  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    margin: '0px',
    boxSizing: 'border-box',
    borderStyle: 'dotted',
    borderWidth: '1px',
    borderColor: '#eee',
    borderRadius: '8px',
  };

  const uploadAreaStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: setAlign || 'flex-start',
    alignItems: 'center',
    width: '100%',
    margin: '0px',
  };

  const uploadLabelStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: setWidth || '200px',
    height: setHeight || '100px',
    border: `2px dashed ${dragOver ? '#4a90e2' : '#ced4da'}`,
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    backgroundColor: dragOver ? 'rgba(74, 144, 226, 0.1)' : '#ffffff',
    flexShrink: 0,
  };

  const imageContainerStyle = {
    position: 'relative',
    width: '100%',
    height: '480px',
    marginBottom: '15px',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s ease',
  };

  const imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'transform 0.3s ease',
  };

  const deleteButtonStyle = {
    position: 'absolute',
    top: '5px',
    right: '5px',
    background: 'rgba(255, 255, 255, 0.9)',
    border: 'none',
    borderRadius: '50%',
    width: '25px',
    height: '25px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    opacity: 0,
  };

  const fileChangeHandler = (event) => {
    const file = event.target.files[0]; // 하나의 파일만 처리
    processFile(file);
  };

  const processFile = (file) => {
    let reader = new FileReader();
    reader.onloadend = (event) => {
      let image = new Image();
      image.src = event.target.result;
      image.onload = () => {
        const imageDataUrl = reader.result; // 이미지 데이터 URL (문자열)
        setPreviewUrl([{ url: imageDataUrl }]); // 이미지 미리보기 업데이트
        setImageUrl([{ url: imageDataUrl }]);   // 이미지 URL 목록 업데이트
        setBizRegCert(imageDataUrl);            // bizRegCert에 문자열 설정
      };
    };
    reader.readAsDataURL(file);
  };
  const deleteImage = () => {
    setBizRegCert('');
    setPreviewUrl([{ url: defImg }]);
    setImageUrl([]); // 빈 배열로 초기화
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files[0]; // 하나의 파일만 처리
    processFile(file);
  };

  return (
    <main style={containerStyle}>
      <div style={uploadAreaStyle}>
        <input
          type="file"
          accept="image/*"
          onChange={fileChangeHandler}
          id="file"
          className="input-file"
          ref={ref}
          style={{ display: 'none' }}
        />
        {previewUrl &&
          previewUrl.map((imageData, index) => (
            <div
              className="imgLoader"
              style={imageContainerStyle}
              key={index}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
              
                const imgElement = e.currentTarget.querySelector('img');
                if (imgElement) {
                  imgElement.style.transform = 'scale(1.1)';
                }
              
                const buttonElement = e.currentTarget.querySelector('button');
                if (buttonElement) {
                  buttonElement.style.opacity = 1;
                }
              }}
              
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
              
                const imgElement = e.currentTarget.querySelector('img');
                if (imgElement) {
                  imgElement.style.transform = 'scale(1)';
                }
              
                const buttonElement = e.currentTarget.querySelector('button');
                if (buttonElement) {
                  buttonElement.style.opacity = 0;
                }
              }}
            >
              <img
                src={imageData.url}
                style={imageStyle}
              />
             {imageData.url !== defImg && (
  <button style={deleteButtonStyle} onClick={deleteImage}>
    <X size={16} color="#ff6b6b" />
  </button>
)}
            </div>
          ))}
      </div>
      <label
        className="upload-label"
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        htmlFor="file"
        style={uploadLabelStyle}
      >
        <Upload size={30} color="#4a90e2" />
        <div style={{ marginTop: '10px', color: '#4a90e2', fontWeight: 500, fontSize: '15px' }}>Upload Image</div>
      </label>
    </main>
  );
});

export default BusinessImgUpload;
